import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEqual } from "@utils/lodash";
import { Button } from "react-bootstrap";

class SubNavBar extends Component {
	shouldComponentUpdate = ({ onClickBack, backText, children }) => {
		const lastProps = this.props;

		if (!isEqual(!!children, !!lastProps.children) || !!children || !!lastProps.children) {
			return true;
		}

		return (
			!isEqual(!!onClickBack, !!lastProps.onClickBack) ||
			!isEqual(!!children, !!lastProps.children) ||
			!isEqual(backText, lastProps.backText)
		);
	};

	render() {
		const { backText, onClickBack, children, className } = this.props;

		return (
			<div className={className}>
				<If condition={!!onClickBack}>
					<Button
						bsStyle="link"
						onClick={onClickBack}
						id="navigate-back"
						aria-label="navigate back"
						className="flex align-center"
					>
						<i className="rkf rkf-chevron-left font-size-18 margin-right-10" />
						<span className="font-regular font-size-14">{backText}</span>
					</Button>
				</If>
				<If condition={!!children}>{children}</If>
			</div>
		);
	}
}

SubNavBar.propTypes = {
	backText: PropTypes.string,
	onClickBack: PropTypes.func,
	children: PropTypes.any,
	className: PropTypes.string,
};

SubNavBar.defaultProps = {
	backText: "Go back",
	onClickBack: undefined,
	children: null,
	className: "sub-nav-bar hidden-print",
};

export default SubNavBar;
